<template>
    <div
            data-cy="menu_left_div"
            class="sidebar-menu modal-row"
            @mouseover="openSidebar()"
            @mouseleave="closeSidebar()">
        <div
                class="sidebar-menu"
                style="direction:ltr;">
            <ul id="configSubmenu">
                <li
                        id="Home"
                        :class="setMenu('Home')">
                    <router-link to="/">
                        <i
                                class="icon-home2"/>
                        <span
                                class="menu-text">{{ t('DOCUMENTS.MENU.HOME') }}</span>
                    </router-link>
                </li>
                <li
                        id="all"
                        :class="setMenu('All')">
                    <router-link to="/all">
                        <i
                                class="icon-documents"/>
                        <span class="menu-text">{{ t('DOCUMENTS.MENU.ALL') }}</span>
                    </router-link>
                </li>
                <li
                        id="waiting"
                        :class="setMenu('Running')">
                    <router-link to="/running">
                        <i
                                class="icon-clock1"/>
                        <span class="menu-text">{{ t('DOCUMENTS.MENU.WAITING') }}
            </span>
                    </router-link>
                </li>
                <li
                        id="Signed"
                        :class="setMenu('Signed')">
                    <router-link to="/signed">
                        <i
                                class="icon-check"/>
                        <span class="menu-text">{{ t('DOCUMENTS.MENU.SIGNEDS') }}</span>
                    </router-link>
                </li>
                <li
                        id="canceled"
                        :class="setMenu('Canceled')">
                    <router-link to="/canceled">
                        <i
                                class="icon-cancel"/>
                        <span class="menu-text">{{ t('DOCUMENTS.MENU.CANCELED') }}</span>
                    </router-link>
                </li>
                <li
                        id="expired"
                        :class="setMenu('Expired')">
                    <router-link to="/expired">
                        <i
                                class="icon-cached"/>
                        <span class="menu-text">{{ t('DOCUMENTS.MENU.EXPIRED') }}</span>
                    </router-link>
                </li>
                <li
                        id="pendingAdm" title="Pendentes Para Administração"
                        :class="setMenu('PendingAdm')">
                    <router-link to="/pendentes-adm">
                        <i
                                class="icon-recent_actors"/>
                        <span class="menu-text">{{ t('DOCUMENTS.MENU.PENDING_ADM') }}</span>
                    </router-link>
                </li>
                <li id="Reports" title="Administração" :class="{'active-page-link': isAdministrationOpen}" v-if="canViewAdministration()">
                    <a href="#" @click.stop.prevent="toggleAdministrationMenu()">
                        <i class="icon-assignment"/>
                        <span class="menu-text">Administração</span>
                        <i :class="isAdministrationOpen ? 'icon-expand_less' : 'icon-expand_more'" class="admin-menu-arrow"/>
                    </a>
                    <ul v-show="isAdministrationOpen" class="admin-submenu">
                        <li id="CompanyIndex" :class="setMenu('CompanyIndex')">
                            <router-link to="/companhias" class="admin-submenu-link">
                                <i class="icon-domain admin-submenu-icon"/>
                                <span class="menu-text">{{ t('COMPANIES.INDEX') }}</span>
                            </router-link>
                        </li>
                        <li id="ReportsIndex" :class="setMenu('Reports')" v-if="canViewReports()">
                            <router-link to="/relatorios" class="admin-submenu-link">
                                <i class="icon-fiber_manual_record admin-submenu-bullet"/>
                                <span class="menu-text">Relatórios</span>
                            </router-link>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {useI18n} from "vue-i18n";
import Validate from '../validate.vue';

export default {
    name: 'MenuComponent',
    props: ['companyId'],
    mixins: [Validate],
    setup() {
        const {t} = useI18n();
        return {t,}
    },

    data() {
        return {
            isAdministrationOpen: false,
        };
    },

    mounted() {
        this.isAdministrationOpen = ['Reports', 'CompanyIndex'].includes(this.$route.name);
    },

    methods: {
        canViewAdministration() {
            const email = localStorage.getItem('mail');

            return !!email && email.endsWith('@r2soft.com.br');
        },
        canViewReports() {
            const email = localStorage.getItem('mail');

            return [
                'r2soft@r2soft.com.br',
                'ricardo@r2soft.com.br',
                'tiago@r2soft.com.br',
                'administracao@r2soft.com.br',
                'lucinneyrosa.r2soft@gmail.com',
                'lucinei@r2soft.com.br',
                'financeiro@r2soft.com.br',
            ].includes(email);
        },
        setMenu(name) {
            return {'active-page-link': this.$route.name == name};
        },
        toggleAdministrationMenu() {
            this.isAdministrationOpen = !this.isAdministrationOpen;
        },

        openSidebar() {
            if (this.pinned) {
                document.getElementById('wrapper').classList.add('sidebar-hovered');
            }
        },

        closeSidebar() {
            if (this.pinned) {
                document.getElementById('configSubmenu').classList.remove('show');
                document.getElementById('wrapper').classList.remove('sidebar-hovered');
            }
        },
    }
}
</script>
<style
        lang="scss">
.modal-row {
    max-height: 100% !important;
    overflow-y: hidden;
    direction: rtl;
}

.modal-row::-webkit-scrollbar {
    width: 7px;
    border-radius: 10px;
    background: transparent !important;
}

.modal-row::-webkit-scrollbar-thumb {
    background: #212529;
    border-radius: 10px;
}

.admin-menu-arrow {
    float: right;
    margin-top: 4px;
}

.admin-submenu {
    list-style: none;
    padding-left: 0;
    margin: 0;
}

.admin-submenu-link {
    padding-left: 32px !important;
}

.admin-submenu-bullet {
    font-size: 8px;
    margin-right: 10px;
    vertical-align: middle;
}

.admin-submenu-icon {
    margin-right: 10px;
}
</style>
